import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/profile/actionTypes';
import { deactivateAccount } from './utils';

export default function* listenDeactivateAccount() {
  yield takeEvery(actionTypes.DEACTIVATE_ACCOUNT, deactivateAccount);
}
